import { render } from "./ReviewModal.vue?vue&type=template&id=7ba73c0b&scoped=true"
import script from "./ReviewModal.vue?vue&type=script&lang=js"
export * from "./ReviewModal.vue?vue&type=script&lang=js"

import "./ReviewModal.vue?vue&type=style&index=0&id=7ba73c0b&scoped=true&lang=scss"

import exportComponent from "/Users/alesandraefimova/Work/x-global-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7ba73c0b"]])

export default __exports__